import type { TourConfig } from './types';

export const clientDetailsTour: TourConfig = {
  id: 'client-details-page',
  name: 'Client Details Tour',
  description: 'Learn how to manage client profiles and their information',
  requiresClientContext: true,
  steps: [
    {
      element: '[data-tour="client-profile-header"]',
      popover: {
        title: 'Client Profile',
        description:
          "This card shows the client's key information: name, status, contact details, and health info like allergies and dietary preferences.",
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="client-edit-button"]',
      popover: {
        title: 'Edit Profile',
        description:
          "Click here to update the client's personal information, health details, and preferences.",
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="client-tabs"]',
      popover: {
        title: 'Client Information Tabs',
        description:
          'Navigate between different sections: Overview, Subscriptions, Diet Plans, Vitals, Counselling, and Attachments.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="tab-overview"]',
      popover: {
        title: 'Overview Tab',
        description:
          'See client summary, health context, and activity timeline at a glance.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="tab-subscriptions"]',
      popover: {
        title: 'Subscriptions Tab',
        description: 'Manage client subscriptions and record payments here.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="tab-diet-plans"]',
      popover: {
        title: 'Diet Plans Tab',
        description:
          'Create and manage weekly diet plans with the 7-day meal grid. Import templates and export PDFs.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="tab-vitals"]',
      popover: {
        title: 'Vitals Tab',
        description:
          'Record and track health metrics like weight, blood pressure, and body measurements. View progress charts.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="tab-counselling"]',
      popover: {
        title: 'Counselling Tab',
        description:
          'Track initial consultation notes and counselling sessions.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="tab-attachments"]',
      popover: {
        title: 'Attachments Tab',
        description:
          'Upload and manage files, reports, and documents related to the client.',
        side: 'bottom',
        align: 'center',
      },
    },
  ],
};
